import * as Sentry from '@sentry/react'
import type { RuntimeConfig } from './runtime-config'

export function initializeObservability(config: RuntimeConfig) {
  const dsn = import.meta.env.VITE_SENTRY_DSN
  if (!dsn) return

  Sentry.init({
    dsn,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || config.environment,
    release: import.meta.env.VITE_RELEASE || config.release,
    sendDefaultPii: false,
    tracesSampleRate: config.environment === 'production' ? 0.1 : 1,
  })
}
